export default __webpack_public_path__ + "static/media/prev-NDNU-4.4733e879.png";